import React from 'react';

function AlignRight({ children, ...rest }) {
  return (
    <div {...rest} style={{ marginLeft: 'auto' }}>
      {children}
    </div>
  );
}

export default AlignRight;
